/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { formatMessage } from "devextreme/localization";
import LoadPanel from "devextreme-react/load-panel";
import notify from "devextreme/ui/notify";
import Form, { Label } from "devextreme-react/form";
import { Button } from "devextreme-react/button";
import { Item } from "devextreme-react/toolbar";
import {
  IsPermisionPathRequired,
  getLeaveDeclarant,
} from "../../../redux/actions";
import { responseMiddleware, responseLeave } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";
import LeaveRegistrationTableList from "./LeaveRegistrationTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import { useAuth } from "../../../contexts/auth";
import { axios, getCurrentPath } from "../../../common";
import PopupConfig from "../../../common/popup";


const
  y = new Date().getFullYear(),
  m = new Date().getMonth()

export default function LeaveRegistrationList() {
  const formData = useRef({});
  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const { isSmall, isXSmall } = useScreenSize();
  const history = useHistory();
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const [isLoading, setIsLoading] = React.useState(false);
  const { leaveDeclarant, loading: leaveLoading } = useSelector(responseLeave);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const { user } = useAuth();
  const [filter, setFilter] = useState({
    Status: [0, 1, 2, 3, 4],
    FromDate: new Date(y, m, 1).toLocaleDateString('en-CA'),
    ToDate: new Date(y, m + 1, 0).toLocaleDateString('en-CA'),
    EmployeeOid: user?.EmployeeOid,
  });

  useEffect(() => {
    dispatch(IsPermisionPathRequired(currentPath));
    UsingIntl("P0014");
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: filter.Status !== null ? `${filter.Status}` : null,
    };
    dispatch(getLeaveDeclarant(newPayload));
  };
  React.useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  const renderActions = ({ data }) => {
    return (
      <div>
        {data?.RequestStatus === 0 && data?.CreatedByEmpCode === user?.EmployeeCode ? (
          <div>
            <Button
              type="danger"
              stylingMode="text"
              // text={formatMessage("Cancel")}
              icon="close"
              onClick={() => handleOpenPopup(data)}
              className="button-rounded mr-2"
            />
            <Button
              type="default"
              stylingMode="text"
              icon="edit" 
              // text={formatMessage("Edit")}
              onClick={() =>
                history.push(`/leave/leave-registration/${data.Oid}`)
              }
              className="button-rounded"
            />
          </div>
        ) : null}
      </div>
    );
  };

  const handleCancelRegistration = async () => {
    const payload = {
      Oid: popupConfig?.data.Oid,
      CancelReason: formData.current.CancelReason,
    };
    try {
      const { status } = await axios.post("CancelRegistLeave", payload);
      if (status !== 200) {
        notify("Registration has not been canceled", "error", 3000);
        handleChangeSelectBox();
        return;
      }
      notify("Registration has been canceled", "success", 3000);
      handleChangeSelectBox();
      handleClosePopup();
      history.push("/leave/leave-registration/list");
    } catch (error) {
      handleChangeSelectBox();
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };
  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        text={formatMessage("CancelPopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form formData={formData.current}>
          <Item dataField="CancelReason" editorType="dxTextArea" colSpan={2}>
            <Label text={formatMessage("CancelReason")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleCancelRegistration}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={() => handleClosePopup()}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      {loading && <LoadPanel visible={loading} />}
      {leaveLoading && <LoadPanel visible={leaveLoading} />}
      {isLoading && <LoadPanel visible={isLoading} />}
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("LeaveRegistration")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Leave")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("LeaveRegistration")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}

          <LeaveRegistrationTableList
            dataGrid={dataGrid}
            renderActions={renderActions}
            middleware={middleware}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            dataSource={leaveDeclarant}
            setIsLoading={setIsLoading}
          />
        </div>
      </div>
    </div>
  );
}
